/* istanbul ignore file */
import { oneOf as codecOneOf, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
const LoginUserDataParser = /* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    /* #__PURE__ */ parsers.object([
        ['username', codecString],
        ['tenantId', /* #__PURE__ */ codecOptional(codecString), 'tenant_id'],
        ['password', codecString],
    ]),
    /* #__PURE__ */ parsers.object([
        ['username', codecString],
        ['tenantId', /* #__PURE__ */ codecOptional(codecString), 'tenant_id'],
        ['ownPassword', codecString, 'own_password'],
    ]),
]);
export const LoginUserData = LoginUserDataParser;
